import { motion } from "framer-motion"
import React, { useState } from "react"

export default function PageTransition({ children }) {
  const [complete, setComplete] = useState(false)
  return (
    <motion.div
      initial={{ opacity: 0 }}
      animate={{ opacity: 1 }}
      exit={{ opacity: 0 }}
      onAnimationComplete={() => setComplete(true)}
      transition={{ duration: 0.3, ease: "easeInOut" }}
    >
      {children}
    </motion.div>
  )
}
